<app-page-header
  title="Transaktionshistorie Vertriebler"
  subtitle="Alle Coin-Transaktionen der Vertriebler im Überblick"
  icon="history"
  variant="gradient">
</app-page-header>

<div class="apple-container">
  <div class="apple-sales-history-table-card apple-card">
    <!-- First Table: Sales Users and Total Coins -->
    <table class="apple-sales-history-users-table">
      <thead>
        <tr class="apple-table-header-row">
          <th class="global-table-header-cell">Sales User</th>
          <th class="global-table-header-cell">Summe Coins vergeben</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entry of salesUsersWithSum$ | async" (click)="setFilterToUser(entry.user)" style="cursor:pointer" class="apple-table-row">
          <td class="global-table-cell">{{ entry.user.user?.firstName }} {{ entry.user.user?.lastName }}</td>
          <td class="global-table-cell">{{ entry.sum }}</td>
        </tr>
      </tbody>
    </table>
    <!-- Filter Bar -->
    <div class="coin-transactions-filter-bar">
      <mat-form-field appearance="outline" style="width: 320px;">
        <mat-label>Nach Name filtern</mat-label>
        <input matInput #filterInput (input)="setFilter(filterInput.value)" placeholder="Name (Kunde oder Vergeben von)" [value]="filter$ | async">
      </mat-form-field>
    </div>
    <!-- Second Table: Coin Transactions -->
    <table class="apple-sales-history-table">
      <thead>
        <tr class="apple-table-header-row">
          <th class="global-table-header-cell">Vergeben von</th>
          <th class="global-table-header-cell">Kunde</th>
          <th class="global-table-header-cell">Grund</th>
          <th class="global-table-header-cell">Auftragsnummer</th>
          <th class="global-table-header-cell">Betrag</th>
          <th class="global-table-header-cell">Datum</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tx of filteredTransactions$ | async" class="apple-table-row">
          <td class="global-table-cell">{{ tx.reason?.reasonText?.includes('Generiert') ? 'Niclen GmbH' : (tx.grantedBy?.firstName + ' ' + tx.grantedBy?.lastName) }}</td>
          <td class="global-table-cell">{{ tx.customer?.userDetails?.firstName }} {{ tx.customer?.userDetails?.lastName }}</td>
          <td class="global-table-cell">{{ tx.reason?.reasonText }}</td>
          <td class="global-table-cell">{{ tx.reflexOrderNo || '-' }}</td>
          <td class="global-table-cell">{{ tx.amount }}</td>
          <td class="global-table-cell">{{ tx.createdDate | date:'dd.MM.yyyy' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
